
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { JobListModule } from '@/store/modules/jobList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'JobListSendJobs'
})
export default class extends GiganautVueDialog {
   
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
    }
  }

  get sendVM() {
    return JobListModule.sendJobsViewModel;
  }

  get searchVM() {
      return JobListModule.jobSearchViewModel;
  }

  get currentWorker() {
    return JobListModule.jobSearchViewModel.selectedWorker;
  }

  get areJobSummariesComplete() {
    if (JobListModule.jobSearchViewModel.selectedJobs.length === 0) {
      return false;
    }
    for (let index = 0; index < JobListModule.jobSearchViewModel.selectedJobs.length; index++) {
      const job = JobListModule.jobSearchViewModel.selectedJobs[index];
      if (job.summary === "") {
        return false;
      }
    }
    return true;
  }

  get loading() {
    return JobListModule.loadingDialog;
  }

  async send() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await JobListModule.sendJobs();
    this.dialog = false;
  }

}
